import { render } from "./HeaderBreadcrumb.vue?vue&type=template&id=05402880"
import script from "./HeaderBreadcrumb.vue?vue&type=script&lang=js"
export * from "./HeaderBreadcrumb.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__